// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItemModal-cls1__e4a7ac9f76753b6dc3ad","cls2":"CreateSocialItemModal-cls2___ff9616403fb8cd8cc01 CreateSocialItemModal-cls1__e4a7ac9f76753b6dc3ad"};